import React, { useState, ReactElement } from "react";
import { TextField, Button, Grid, Container, Typography, Card, CardActionArea, CardMedia, CardContent, Box, Tab, Tabs } from "@mui/material";
import {
  MessageContainer,
  DownloadButton,
  BackButton,
  CloseButton,
  FullContainer,
  ButtonContainer
} from "./ctepdownload.styled"
import { useNavigate } from 'react-router-dom';
import {ReactComponent as DownloadIcon} from "assets/images/Download_white.svg";


function CTEPDownload(props) {
    const navigate = useNavigate();

    const CloseButtonClick = () => {
        navigate(-1);
    }

    const prevButtonClick = () => {
        props.onPrevButtonClick()
    }

    return (
      <FullContainer>
        <MessageContainer>
          <DownloadButton>
            <DownloadIcon style={{position: "relative", right: ".5em"}}/>
            <a href={props.downloadLink} target="_blank"
            download="SAR_Report_for_SmallSol.pdf">
              Download my custom Report
            </a>
        </DownloadButton>
        </MessageContainer>
        <ButtonContainer>
          <BackButton onClick={prevButtonClick}>Go Back</BackButton>
          <CloseButton onClick={CloseButtonClick}>Close</CloseButton>
        </ButtonContainer>
      </FullContainer>



    );
}

export default CTEPDownload;